import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Heading,
  HStack,
  chakra,
  SimpleGrid,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import AddProductDrawer from '../components/merchant/AddProductDrawer';
import AuthModal from '../components/merchant/AuthModal';
import WrapContent from '../components/WrapContent';
import { useCtx } from '../context/AppContext';
import { popularProducts } from '../data';

function Merchant() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { changeAuth } = useCtx();
  const [authType, setAuthType] = useState('login');

  const [merchantAuth, setAuth] = useState(false);

  const changeAuthType = val => {
    const authStates = ['confirm', 'login', 'signup'];
    setAuthType(authStates[val]);
    onOpen();
  };
  const getMerchantProperties = part =>
    Object.entries(merchantAuth).find(([k, v]) => k.startsWith(part))?.[1];

  useEffect(() => {
    let data = localStorage.getItem('merchantdata');
    console.log(data);
    if (data) {
      data = JSON.parse(data);
      setAuth(data);
      changeAuth(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <WrapContent>
        {!merchantAuth && (
          <>
            <Center minH="85vh" h="full" py="40px" flexDir="column">
              <Heading as="h1">Merchant Onboarding</Heading>
              <Text fontSize="lg" py="5">
                {' '}
                SIgn up as a merchant to add your items to the market place
              </Text>
              <HStack spacing="5">
                <Button
                  onClick={() => changeAuthType(2)}
                  colorScheme="purple"
                  rounded="xl"
                >
                  Sign up now!
                </Button>
                <Button
                  onClick={() => changeAuthType(1)}
                  colorScheme={'teal'}
                  rounded="xl"
                >
                  Go to Dashboard
                </Button>
              </HStack>
              <Button
                variant="flushed"
                my="4"
                colorScheme={'teal'}
                rounded="xl"
                size="xs"
                onClick={() => changeAuthType(0)}
              >
                Click her to confirm email.
              </Button>
              <Button
                my="4"
                colorScheme={'teal'}
                rounded="xl"
                size="xs"
                onClick={() => setAuth(true)}
              >
                Demo Dashboard
              </Button>
            </Center>
            <AuthModal
              isOpen={isOpen}
              onClose={onClose}
              type={authType}
              changeAuthType={changeAuthType}
              setAuth={setAuth}
            />
          </>
        )}

        {merchantAuth && (
          <Box minH="100vh" py="10">
            <Stack flexDir={['column', 'column', 'row']}>
              <Stack w={['full', 'full', '65%', '75%']} mr={[0, 0, 10]}>
                <Box p="2" rounded="lg">
                  <Text as="b" fontSize="sm">
                    Hi {merchantAuth.name.split(' ')[0]}, Welcome back!
                  </Text>
                  <Heading as="h1" fontSize="2xl" fontWeight="500">
                    Dashboard
                  </Heading>
                  <SimpleGrid columns={[2, 2, 3]} spacing="5" py="5">
                    <Center
                      p="4"
                      bg="teal.400"
                      color="white"
                      rounded="lg"
                      flexDir={'column'}
                    >
                      <Text as="b" fontSize="xs">
                        total sales
                      </Text>
                      <Text>$3000</Text>
                    </Center>
                    <Center
                      p="4"
                      bg="teal.400"
                      color="white"
                      rounded="lg"
                      flexDir={'column'}
                    >
                      <Text as="b" fontSize="xs">
                        total orders
                      </Text>
                      <Text>40 orders</Text>
                    </Center>
                    <Center
                      p="4"
                      bg="teal.400"
                      color="white"
                      rounded="lg"
                      flexDir={'column'}
                    >
                      <Text as="b" fontSize="xs">
                        products listed
                      </Text>
                      <Text>10</Text>
                    </Center>
                  </SimpleGrid>
                  <Divider />
                  <Stack spacing="5" py="5">
                    <Box>
                      <HStack justifyContent={'space-between'}>
                        <Box>
                          <Box as="p" fontSize="xs" fontWeight="600">
                            {getMerchantProperties('custom:cat')} Store
                          </Box>
                          <Heading as="h1" fontSize="xl" fontWeight="500">
                            {getMerchantProperties('custom:bus')}
                          </Heading>
                        </Box>
                        <AddProductDrawer />
                      </HStack>
                      <SimpleGrid py="5" columns={2} spacing="10">
                        {popularProducts.map((p, i) => (
                          <Item p={p} key={i} />
                        ))}
                      </SimpleGrid>
                    </Box>
                  </Stack>
                </Box>
              </Stack>
              <Stack pb="40px" w={['full', 'full', '30%', '35%']}>
                <Box bg="gray.50" rounded="lg">
                  <Heading p="5" as="h1" fontSize="2xl" fontWeight="500">
                    Recent Orders
                  </Heading>
                  <Box>
                    <OrdersTable />
                  </Box>
                </Box>
              </Stack>
            </Stack>
          </Box>
        )}
      </WrapContent>
    </>
  );
}

export default Merchant;

function Item({ p }) {
  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      w="full"
      mx="auto"
    >
      <Box
        bg="gray.300"
        h={64}
        w="full"
        rounded="lg"
        shadow="md"
        bgSize="contain"
        bgRepeat={'no-repeat'}
        bgPos="center"
        style={{
          backgroundImage: `url(${p.img}`,
        }}
      ></Box>

      <Box
        w={{
          base: 48,
          md: 56,
        }}
        bg="white"
        _dark={{
          bg: 'gray.800',
        }}
        mt={-10}
        shadow="lg"
        rounded="lg"
        overflow="hidden"
      >
        <chakra.h3
          py={2}
          textAlign="center"
          fontWeight="bold"
          fontSize="sm"
          textTransform="uppercase"
          color="gray.800"
          _dark={{
            color: 'white',
          }}
          letterSpacing={1}
        >
          {p.title}
        </chakra.h3>

        <Flex
          alignItems="center"
          justifyContent="space-between"
          py={2}
          px={3}
          bg="gray.200"
          _dark={{
            bg: 'gray.700',
          }}
        >
          <chakra.span
            fontWeight="bold"
            color="gray.800"
            _dark={{
              color: 'gray.200',
            }}
          >
            {p.price} CFX
          </chakra.span>
          <chakra.button
            bg="gray.800"
            fontSize="xs"
            fontWeight="bold"
            color="white"
            px={2}
            py={1}
            rounded="lg"
            textTransform="uppercase"
            _hover={{
              bg: 'gray.700',
              _dark: {
                bg: 'gray.600',
              },
            }}
            _focus={{
              bg: 'gray.700',
              _dark: {
                bg: 'gray.600',
              },
              outline: 'none',
            }}
          >
            Manage
          </chakra.button>
        </Flex>
      </Box>
    </Flex>
  );
}

const OrdersTable = () => {
  return (
    <TableContainer>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Order Id</Th>
            <Th>Customer</Th>
            <Th isNumeric>Amount</Th>
            <Th>Date</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>12347</Td>
            <Td>John Doe</Td>
            <Td isNumeric>$2598</Td>
            <Td>{new Date().toLocaleDateString()}</Td>
          </Tr>
          <Tr>
            <Td>12347</Td>
            <Td>John Doe</Td>
            <Td isNumeric>$2598</Td>
            <Td>{new Date().toLocaleDateString()}</Td>
          </Tr>
          <Tr>
            <Td>12347</Td>
            <Td>John Doe</Td>
            <Td isNumeric>$2598</Td>
            <Td>{new Date().toLocaleDateString()}</Td>
          </Tr>
          <Tr>
            <Td>12347</Td>
            <Td>John Doe</Td>
            <Td isNumeric>$2598</Td>
            <Td>{new Date().toLocaleDateString()}</Td>
          </Tr>
          <Tr>
            <Td>12347</Td>
            <Td>John Doe</Td>
            <Td isNumeric>$2598</Td>
            <Td>{new Date().toLocaleDateString()}</Td>
          </Tr>
          <Tr>
            <Td>12347</Td>
            <Td>John Doe</Td>
            <Td isNumeric>$2598</Td>
            <Td>{new Date().toLocaleDateString()}</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};
